export default __webpack_public_path__ + "static/media/warningiconsvg.63796d0b.svg";